/**
 * PremiumUpgradeModal — info premium (Fase 3; dipakai ulang oleh reminder
 * Beranda Fase 4 via props title/body opsional).
 *
 * Dua konteks pemakaian:
 *  - Pasca-top-up (default copy): "Kamu sekarang Premium!"
 *  - Reminder Beranda (title/body custom): ajakan lengkapi preferensi.
 * CTA utama ke /akun/edit-preferensi; "Nanti saja" menutup tanpa menghukum.
 * Dibangun di atas RN Modal, pola sama dengan SegeraHadirModal.
 */

import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';

import { Brand, Radii, Spacing } from '@/constants/theme';

interface PremiumUpgradeModalProps {
  visible: boolean;
  /** Judul kartu. Default: copy pasca-top-up. */
  title?: string;
  /** Body kartu. Default: copy pasca-top-up. */
  body?: string;
  onChoose: () => void;
  onLater: () => void;
}

export function PremiumUpgradeModal({
  visible,
  title = 'Kamu sekarang Premium!',
  body = 'Pilihan aktivitas bertambah dari 5 menjadi 15. Yuk lengkapi preferensi supaya rekomendasi worksheet makin pas untuk si kecil.',
  onChoose,
  onLater,
}: PremiumUpgradeModalProps) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onLater}>
      <Pressable style={styles.backdrop} onPress={onLater}>
        {/* Inner Pressable mencegah tap backdrop menutup saat tap di kartu. */}
        <Pressable style={styles.card} onPress={(e) => e.stopPropagation?.()}>
          <Text style={styles.emoji}>✨</Text>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.body}>{body}</Text>
          <Pressable
            onPress={onChoose}
            style={({ pressed }) => [styles.cta, pressed && styles.ctaPressed]}
            accessibilityRole="button"
            accessibilityLabel="Pilih aktivitas premium"
          >
            <Text style={styles.ctaText}>Pilih Aktivitas</Text>
          </Pressable>
          <Pressable
            onPress={onLater}
            style={({ pressed }) => [styles.later, pressed && styles.ctaPressed]}
            accessibilityRole="button"
            accessibilityLabel="Ingatkan nanti"
          >
            <Text style={styles.laterText}>Nanti saja</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: Spacing.four,
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: Radii.medium,
    padding: Spacing.four,
    width: '100%',
    maxWidth: 360,
    alignItems: 'center',
    gap: Spacing.two,
  },
  emoji: { fontSize: 36 },
  title: { color: Brand.primary, fontSize: 18, fontWeight: '700', textAlign: 'center' },
  body: { color: '#201c23', fontSize: 14, lineHeight: 21, textAlign: 'center' },
  cta: {
    backgroundColor: Brand.primary,
    borderRadius: Radii.pill,
    marginTop: Spacing.two,
    paddingHorizontal: Spacing.four,
    paddingVertical: Spacing.two,
    width: '100%',
    alignItems: 'center',
  },
  ctaText: { color: '#ffffff', fontSize: 15, fontWeight: '700' },
  later: { paddingHorizontal: Spacing.four, paddingVertical: Spacing.two },
  laterText: { color: Brand.primary, fontSize: 13, fontWeight: '600' },
  ctaPressed: { opacity: 0.75 },
});
